// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSwitch_switch__HAC+a","disabled":"ToggleSwitch_disabled__eLyZw","slider":"ToggleSwitch_slider__wyrT1"};